/**
 * Calculate remaining trial days from a trial end date.
 *
 * Returns 0 if:
 * - trialEndAt is undefined (no trial configured)
 * - price is 0 (free plan — trials don't apply)
 * - trial has already ended (trialEndAt is in the past)
 *
 * Otherwise returns the number of days remaining, rounded up (ceil).
 */
export function getTrialDaysLeft(trialEndAt: string | undefined, price: number): number {
  if (trialEndAt === undefined) {
    return 0;
  }
  if (price <= 0) {
    return 0;
  }
  const endDate = new Date(trialEndAt);
  const now = new Date();
  if (endDate < now) {
    return 0;
  }
  const timeDiff = Math.abs(endDate.getTime() - now.getTime());
  return Math.ceil(timeDiff / (1000 * 3600 * 24));
}
